export default __webpack_public_path__ + "static/media/speaker.d2fa011a.svg";